import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, typeof as _typeof, slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getPageSize } from '../utils/pageSize.js';
import { loadData } from '../utils/ApiUtil.js';
import find from 'lodash/find.js';
import isString from 'lodash/isString.js';

var buildUrl = function buildUrl(base) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var includes = params.includes,
      filters = params.filters,
      sorts = params.sorts,
      page = params.page,
      query = params.query,
      fields = params.fields;
  var filterParams = getFilterParams(filters);
  var sortParams = getSortParams(sorts);
  var pageParams = getPageParams(page);
  var queryParams = getQueryParams(query);
  var fieldParams = getFieldParams(fields);
  var paramString = ["".concat(filterParams), "".concat(includes ? "include=".concat(includes) : ''), "".concat(sortParams ? "sort=".concat(sortParams) : ''), "".concat(pageParams ? "".concat(pageParams) : ''), "".concat(queryParams ? "".concat(queryParams) : ''), "".concat(fieldParams ? "".concat(fieldParams) : '')].filter(Boolean).join('&');
  return "".concat(base).concat(base.indexOf('?') === -1 ? '?' : '&').concat(paramString);
};

var getFilterParams = function getFilterParams(filters) {
  if (!filters) return '';
  if (isString(filters)) return filters;
  return Object.keys(filters).filter(function (key) {
    return filters[key] !== null && filters[key] !== undefined;
  }).map(function (key) {
    if (filters[key] instanceof Array) {
      return filters[key].map(function (f) {
        return "filter[".concat(key, "][]=").concat(encodeURIComponent(f));
      }).join('&');
    } else {
      return "filter[".concat(key, "]=").concat(encodeURIComponent(filters[key]));
    }
  }).join('&');
};

var getSortParams = function getSortParams(sorts) {
  if (!sorts) {
    return '';
  }

  if (!Array.isArray(sorts)) {
    sorts = [sorts];
  }

  return sorts.map(function (sort) {
    if (!sort) return '';
    return "".concat(sort.direction === 'desc' ? '-' : '').concat(sort.value);
  }).filter(Boolean).join(',');
};

var getPageParams = function getPageParams(page) {
  if (_typeof(page) === 'object' && page !== null) {
    page.size = page.size || getPageSize();
    page.number = page.number || 1;
  } else if (Number.isInteger(page)) {
    page = {
      number: page,
      size: getPageSize()
    };
  } else {
    page = {
      number: 1,
      size: getPageSize()
    };
  }

  return page ? "page[number]=".concat(page.number || 1, "&page[size]=").concat(page.size) : '';
};

var getQueryParams = function getQueryParams(query) {
  if (!query) return '';
  return Object.entries(query).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2);

    _ref2[0];
    var value = _ref2[1];
    return value !== null && value !== undefined;
  }).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2);

    _ref4[0];
    var value = _ref4[1];
    return !!value.term;
  }).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    var param = "query[".concat(key, "][term]=").concat(encodeURIComponent(value.term));
    var fields = Object.entries(value.fields).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          fieldKey = _ref8[0],
          fieldValue = _ref8[1];

      return "".concat(fieldKey, ".").concat(fieldValue);
    }).join(',');
    param += "&query[".concat(key, "][fields]=").concat(fields);
    return param;
  }).join('&');
};

var getFieldParams = function getFieldParams(fields) {
  if (!fields) return '';
  return Object.entries(fields).filter(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2);

    _ref10[0];
    var value = _ref10[1];
    return value !== null && value !== undefined;
  }).map(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
        key = _ref12[0],
        value = _ref12[1];

    return "fields[".concat(key, "]=").concat(value);
  }).join('&');
};

var getData = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(base) {
    var params,
        url,
        authToken,
        headers,
        json,
        data,
        _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            url = buildUrl(base, params);
            authToken = params.authToken;
            headers = {};

            if (authToken) {
              headers = {
                Authorization: "Bearer ".concat(authToken)
              };
            }

            _context.next = 7;
            return loadData(url, {
              headers: headers,
              mode: 'cors'
            }, false);

          case 7:
            json = _context.sent;
            data = buildFromJsonApi(json);
            return _context.abrupt("return", {
              data: data,
              meta: json.meta
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getData(_x) {
    return _ref13.apply(this, arguments);
  };
}();

function buildFromJsonApi(json) {
  return buildDataFromJsonApi(json.data, json.included);
}

function buildDataFromJsonApi(data, included) {
  if (Array.isArray(data)) {
    return data.map(function (dataValue) {
      return buildDataObjectFromJsonApi(dataValue, included);
    });
  }

  return buildDataObjectFromJsonApi(data, included);
}

function buildDataObjectFromJsonApi(data, included) {
  return Object.assign({
    id: data.id
  }, data.attributes, data.relationships && included ? Object.entries(data.relationships).reduce(function (object, _ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
        key = _ref15[0],
        value = _ref15[1];

    return _objectSpread2(_objectSpread2({}, object), {}, _defineProperty({}, key, buildRelationshipFromJsonApi(value.data, included)));
  }, {}) : {});
}

function buildRelationshipFromJsonApi(data, included) {
  if (!data) return;

  if (Array.isArray(data)) {
    return data.map(function (dataValue) {
      return buildRelationshipObjectFromJsonApi(dataValue, included);
    });
  }

  return buildRelationshipObjectFromJsonApi(data, included);
}

function buildRelationshipObjectFromJsonApi(object, included) {
  var includedObject = find(included, object);

  if (!includedObject) {
    return null;
  }

  return buildDataFromJsonApi(includedObject, included);
}

export { buildUrl, getData, getFieldParams, getFilterParams, getPageParams, getQueryParams, getSortParams };